'use strict';

import angular from 'angular';
import FormController from 'app/controllers/form';

class SpendingTypeController extends FormController {
    /* @ngInject */
    constructor(
        SpendingTypesService,
        $scope,
        $mdToast
    ) {
        let spendingType = $scope.$parent.$resolve.spendingType;
        super(
            spendingType,
            'Tipo de gasto',
            SpendingTypesService
        );

        Object.assign(this, {
            SpendingTypesService,
            $mdToast
        });
        this.btnEnabled = true;
    }

    $onInit() {
        super.$onInit();
    }
}

export default SpendingTypeController;
